module.exports = {
    DATE: 'date',
    SCHOOL_YEAR: 'schoolYear',
    EXPERIENCE_ID: 'experienceId',
    STUDENT_ID: 'studentId',
    REFLECTION_ID: 'reflectionId',
    FACILITATOR_ID: 'facilitatorId',
    DIMENSION_ID: 'dimensionId',
    TEXT_SEARCH: 'textSearch'
}